import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks';

import '../home-page-content.scss';
import FavouritesRecentopenSection from '../section-1/favourites-recently-opened-section';
import PortfolioTabs from '../section-2/portfolio-section2';
import AnnouncementsSection from '../section-3/announcements-updates-section';

const CustomGrid = styled(Grid)(({ theme }) => ({
  height: 'inherit',
  margin: 'auto',
  fontSize: '12px',
  textAlign: 'center'
}));

const CustomPaper = styled(Paper)(({ theme }) => ({
  height: 'inherit'
}));

const parentHeight = '100%';
const childHeight = '220px';

export default function HomepageBase() {
  return (
    <div style={{ margin: '20px', height: parentHeight }}>
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <Grid container spacing={2} height='inherit'>
          <CustomGrid item xs={3}>
            <CustomPaper elevation={4}>
              <FavouritesRecentopenSection parentHeightValue={childHeight} />
            </CustomPaper>
          </CustomGrid>
          <CustomGrid item xs={6}>
            <CustomPaper elevation={4}>
              <PortfolioTabs parentHeightValue={childHeight} />
            </CustomPaper>
          </CustomGrid>
          <CustomGrid item xs={3}>
            <CustomPaper elevation={4}>
              <AnnouncementsSection parentHeightValue={childHeight} />
            </CustomPaper>
          </CustomGrid>
        </Grid>
      </Box>
    </div>
  );
}
